var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-icon',{attrs:{"width":"82","height":"16","name":"t-large-logo","viewBox":"0 0 150 31"}})}
var staticRenderFns = []

export { render, staticRenderFns }